module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_4.5e40c3b9.png";